import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { BookingProvider } from "@/components/BookingProvider";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import HomePage from "@/pages/Home";
import AboutPage from "@/pages/About";
import OwnersPage from "@/pages/Owners";
import BuyersPage from "@/pages/Buyers";
import ContactPage from "@/pages/Contact";
import WorkshopsPage from "@/pages/Workshops";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

function App() {
  return (
    <BrowserRouter>
      <BookingProvider>
        <ScrollToTop />
        <div className="App min-h-screen flex flex-col bg-cream">
          <Navigation />
          <div className="flex-1">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/owners" element={<OwnersPage />} />
              <Route path="/buyers" element={<BuyersPage />} />
              <Route path="/workshops" element={<WorkshopsPage />} />
              <Route path="/contact" element={<ContactPage />} />
            </Routes>
          </div>
          <Footer />
        </div>
      </BookingProvider>
    </BrowserRouter>
  );
}

export default App;
